<div class="flex-row flex">
    <cb-datepicker class="cb-margin-right"
                   [label]="startDateLabel"
                   [name]="name + '_startDateInputName'"
                   [(ngModel)]="startDateLocal"
                   (change)="dateChanged()"
                   [required]="required"
                   [nonWorkingDays]="nonWorkingDays"
                   [pickerType]="pickerType"
                   [disabled]="disabled">
    </cb-datepicker>
    <cb-input class="cb-margin-right"
              style="height: 78px;"
              label="Duration (Days)"
              type="number"
              [minimum]="MIN_DURATION"
              [maximum]="MAX_DURATION"
              [name]="name + '_durationInputName'"
              [(ngModel)]="durationLocal"
              (ngModelChange)="dateChanged()"
              [required]="required"
              [disabled]="disabled">
    </cb-input>
    @if (calculatingEndDate) {
        <cb-loading-spinner
            message="">
        </cb-loading-spinner>
    }
    @if (!calculatingEndDate) {
        <cb-display-value-new
            label="End Date"
            [value]="endDate | date"></cb-display-value-new>
    }
</div>
